import React, {useEffect, useState} from 'react';
import {Button, Card, Checkbox, Form, Input, message, Modal, Table, Spin} from "antd";
import {useSelector} from "react-redux";
import {
    useGetOneRoleQuery,
    useGetRolesQuery,
    useUpdateOneRoleMutation
} from "../../../../slices/rootApiSlices/roleApiSlice";
import {SaveOutlined} from "@ant-design/icons";

const RoleUpdateModal = ({visible, onClose, data}) => {

    const [form] = Form.useForm();
    const {user} = useSelector(state => state.auth);
    const {data: roleData, error, isLoading: roleDataLoading} = useGetOneRoleQuery({token: user?.token, id: data});
    const [updateRoleHandle, {isLoading: updateLoading}] = useUpdateOneRoleMutation();
    const {refetch} = useGetRolesQuery(user?.token);
    const [permissionData, setPermissionData] = useState({});
    const [roleName, setRoleName] = useState("");

    useEffect(() => {
        if (roleData?.data) {
            form.setFieldsValue({
                roleName: roleData?.data?.name,
            });
            setPermissionData(roleData?.data?.permission?.action || {});
            setRoleName(roleData?.data?.name || "");
        }
    }, [roleData?.data, form]);

    const columns = [
        {
            title: 'Rol Adı',
            dataIndex: 'name',
            key: 'name',
            render: (text) => {
                switch (text) {
                    case 'Roles':
                        return 'Roller';
                    case 'Users':
                        return 'Kullanıcılar';
                    case 'Drivers':
                        return 'Sürücüler';
                    case 'Vehicles':
                        return 'Araçlar';
                    case 'Lines':
                        return 'Güzergahlar';
                    case 'reports':
                        return 'Raporlar';
                    case 'Live':
                        return 'Canlı İzleme';
                    default:
                        return text;
                }
            }
        },
        {
            title: 'Görüntüleme',
            dataIndex: 'read',
            key: 'read',
            render: (_, record) => <Checkbox checked={record.read}/>,
        },
        {
            title: 'Silme',
            dataIndex: 'delete',
            key: 'delete',
            render: (_, record) => <Checkbox checked={record.delete}/>,
        },
        {
            title: 'Ekleme',
            dataIndex: 'write',
            key: 'write',
            render: (_, record) => <Checkbox checked={record.write}/>
        },
        {
            title: 'Güncelleme',
            dataIndex: 'update',
            key: 'update',
            render: (_, record) => <Checkbox checked={record.update}/>
        },
    ];

    const dataSource = Object.keys(permissionData || {}).map((key) => ({
        key: key,
        name: key.charAt(0).toUpperCase() + key.slice(1),
        read: permissionData[key]?.read || false,
        delete: permissionData[key]?.delete || false,
        write: permissionData[key]?.write || false,
        update: permissionData[key]?.update || false,
    }));

    const handleCheckboxChange = (category, actionType) => {
        setPermissionData((prevData) => ({
            ...prevData,
            [category]: {
                ...prevData[category],
                [actionType]: !prevData[category][actionType],
            },
        }));
    };

    const onFinish = async () => {
        const roleData = {
            name: roleName,
            action: permissionData
        }
        try {
            const res = await updateRoleHandle({token: user?.token, data: roleData, id: data}).unwrap();
            if (res?.status) {
                onClose();
                refetch();
                form.setFieldsValue({
                    roleName: "",
                });
                message.success('Rol güncelleme işlemi başarılı', 3)
            }
        } catch (e) {
            message.error(e?.data?.messageTR)
            onClose();
        }
    };

    return (
        <Modal
            width={900}
            title="Rol Güncelleme"
            open={visible}
            onCancel={onClose}
            footer={[
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={roleDataLoading || updateLoading}
                    onClick={onFinish}
                    disabled={!roleName}
                    icon={<SaveOutlined/>}
                >
                    Güncelle
                </Button>,
            ]}
        >
            <Card type="inner" size="small" bordered={true}>
                <Form
                    name="update-role"
                    onFinish={onFinish}
                    onFinishFailed={error?.data?.messageTR}
                    autoComplete="off"
                    form={form}
                >
                    <Form.Item label="Rol Adı" style={{marginBottom: 10}}>
                        <Input
                            style={{display: 'inline-block', width: 'calc(100% - 8px)', margin: '0 8px'}}
                            name="roleName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Lütfen role adı giriniz!',
                                },
                            ]}
                            onChange={(e) => setRoleName(e.target.value)}
                            value={roleName}
                            disabled={roleDataLoading || updateLoading}
                            placeholder="Rol Adı"
                        />
                    </Form.Item>
                    <Form.Item label="Rolün Yetkileri">
                        {roleDataLoading ? (
                            <Spin/>
                        ) : (
                            <Table
                                rowKey="key"
                                bordered={true}
                                dataSource={dataSource}
                                size="small"
                                loading={updateLoading}
                                pagination={false}
                                columns={[
                                    ...columns.slice(0, 1),
                                    ...columns.slice(1).map((col) => ({
                                        ...col,
                                        render: (_, record) => (
                                            <Checkbox checked={record[col.dataIndex]}
                                                      onChange={() => handleCheckboxChange(record.key, col.dataIndex)}/>
                                        ),
                                    })),
                                ]}
                            />
                        )}
                    </Form.Item>
                </Form>
            </Card>
        </Modal>
    );
};

export default RoleUpdateModal;
